import React from 'react';

import './Tooltip.module.css';

const Tooltip = ({ children, title, type }) => {
  return (
    <div styleName={`tooltip ${type}`}>
      {<span styleName="label">{title}</span>}
      <div styleName="content">
        {title && <h4>{title}</h4>}
        {children}
      </div>
    </div>
  );
};

export default Tooltip;
